import React, { Component } from 'react'
import './index.less'

interface LookCodeInfoProps {
    tips: string[]
}
export default class LookCodeInfo extends Component<LookCodeInfoProps> {
    _tipsItem() {
        return this.props.tips.map((item, key) => {
            return <span key={key} className='lookcode-info-tips'>{item}</span>
        })
    }
    render() {
        return (
            <div className='lookcode-info-bg'>
                <div className='lookcode-info-cell'>
                    {this._tipsItem()}
                </div>
            </div>

        )
    }
}